import React from 'react'
import App from './app'
import appStore from "./app-store";
import {Provider} from 'react-redux';
import {isMobile} from 'react-device-detect';
import MobileLanding from './utils/mobile-landing/mobileLanding';

class AppWrapper extends React.Component {
    render() {

        return (
            isMobile ?
                <MobileLanding/>
                :
                <Provider store={appStore}>
                    <App/>
                </Provider>
        )
    }
}

export default AppWrapper;
